module.exports = __webpack_public_path__ + "8f05baab2e8bf44e402f535c657b9b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/close-blue.png
// module id = 465
// module chunks = 0